var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart-heading"},[_c('h1',[_vm._v(_vm._s(_vm.t('chartHeading.overview')))]),_vm._v("\n  "+_vm._s(_vm.t('chartHeading.poweredBy'))+" "),_c('a',{attrs:{"href":_vm.url,"rel":"nofollow noopener noreferrer","target":"_blank"}},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }